import gql from 'graphql-tag';

const GET_SIMULATIONS_QUERY = gql`
  query(
      $contractNumber: String!,
      $language: String!,
      $page: PaginationDetails!) {  
    simulations(
      contractNumber: $contractNumber,
      language: $language,
      page: $page,
    ){
      limit 
      offset 
      totalItems 
      isLastPage 
      firstItemIndex 
      lastItemIndex 
      items {  
        calculationDate  
        calculationRequestId
        grossSalary  
        pdfUri
        simulationResults {    
          simulationResultId    
          calculationTypeKey {
            calculationTypeId
            name
          }    
          resultKey 
          policyChange   
          simulationResultId  
        } 
      }  
    }
  }
`;

export default GET_SIMULATIONS_QUERY;
